/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import PropTypes from "prop-types"

import classNames from "classnames"
import * as actions from "../../../services/actions"

// Selectors
import { getBehaviorTypes } from "../../../services/selectors/visionSelectors"

class Tabs extends Component {
  static propTypes = {
    tabActive: PropTypes.number,
    actions: PropTypes.oneOfType([PropTypes.object]),
    children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    keys: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    callData: PropTypes.bool
  }

  static defaultProps = {
    tabActive: 1,
    actions: {},
    keys: [],
    className: null,
    callData: true
  }

  constructor(props) {
    super(props)

    this.state = {
      tabActive: props.tabActive
    }
  }

  setActive = (index, e) => {
    const { actions, keys, callData } = this.props

    e.preventDefault()
    actions.setTab(index, keys, callData)

    this.setState({ tabActive: index }, () => {})
  }

  _getMenuItems = () => {
    let { children } = this.props
    const { tabActive } = this.state
    if (!children) {
      throw new Error("Tabs must contain at least one Tabs.Panel")
    }

    if (!Array.isArray(children)) {
      children = [children]
    }

    const $menuItems = children
      .map($panel => (typeof $panel === "function" ? $panel() : $panel))
      .filter($panel => $panel)
      .map(($panel, index) => {
        const { title } = $panel.props
        const classes = classNames(
          "tabs-nav-menu-item",
          tabActive === index + 1 && "is-active"
        )

        return (
          <li key={index} className={classes}>
            <a onClick={this.setActive.bind(this, index + 1)}>{title}</a>
          </li>
        )
      })

    return (
      <nav className="tabs-nav">
        <ul className="tabs-nav-menu">{$menuItems}</ul>
      </nav>
    )
  }

  _getSelectedPanel = () => {
    const { tabActive } = this.state
    const { children } = this.props
    const index = tabActive - 1
    const $panel = children[index]

    return <article className="tab-nav-panel">{$panel}</article>
  }

  render() {
    const { className } = this.props
    const classNameTabs = classNames("tabs", className)
    return (
      <div className={classNameTabs}>
        {this._getMenuItems()}
        {this._getSelectedPanel()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  keys: getBehaviorTypes(state)
})

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(actions, dispatch)
  }
}

// export Tabs
export default connect(mapStateToProps, mapDispatchToProps)(Tabs)
